<template>
  <button
    class="toggle-button-parts"
    @click="toggle"
    :class="{ 'toggle-button-parts--current': enabled }"
  >
    <slot />
  </button>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面 動画プレーヤー オンオフ切り替えボタン コンポーネント
 */
export default defineComponent({
  name: 'ToggleButtonParts',
  props: {
    /**
     * 表示コンテンツモード
     */
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    toggle(): void {
      /**
       * 有効化切り替え
       */
      this.$emit('toggle')
    },
  },
})
</script>

<style lang="scss" scoped>
.toggle-button-parts {
  &__icon {
    path {
      fill: rgba(255, 255, 255, 70%);
    }
  }

  &--current {
    background: rgba($green-light, 20%);
  }
}
</style>

<style lang="scss">
.toggle-button-parts {
  &--current {
    svg path {
      fill: $green-light;
    }
  }
}
</style>
